/**
 * Controller for two column directive.
 * (Maybe improvement in future: multi-column directive with defined breakpoints)
 */
angular.module('impactx.product').controller('ixTwoColumnTableController', ['$scope', '$window', function($scope, $window) {
    //Using $scope to get config from, but storing all the stuff in controller.
    var self = this,
        hasBreakpoint = false,
        currentWidthFn,
        resizeMethod;

    //Copy to controller's scope.
    self.isSingleColumnInt = $scope.isSingleColumn || false;
    self.highlightSearchText = $scope.highlightSearchText || false;
    self.windowAsWidthReference = $scope.useWindowWidth || false;
    self.widthElementId = $scope.widthElementId || 'main-content';

    //Validate number
    if($scope.oneColumnBreakpoint) {
        if(typeof $scope.oneColumnBreakpoint !== 'number') {
            $scope.oneColumnBreakpoint = parseInt($scope.oneColumnBreakpoint, 10);
        }

        hasBreakpoint = (typeof $scope.oneColumnBreakpoint === 'number' && !isNaN($scope.oneColumnBreakpoint));
    }

    if(hasBreakpoint && $scope.oneColumnBreakpoint > 200) {

        self.oneColumnBreakpoint = $scope.oneColumnBreakpoint;

        //Binding to method
        if(self.windowAsWidthReference) {
            currentWidthFn = (function(win) {
                // console.log("CREATE WIDTH FUNC FOR WINDOW");
                return function() {
                    return win.innerWidth;
                };
            }($window));
        }
        else {
            //main-content maybe ???
            currentWidthFn = (function(elemId) {
                // console.log("CREATE WIDTH FUNC FOR ELEMENT:", elemId);
                return function() {
                    return impactX.elementWidth(elemId);
                };
            }(self.widthElementId));
        }

        self.ownRefenceWidth = currentWidthFn();

        self.isSingleColumnInt = self.ownRefenceWidth < self.oneColumnBreakpoint;

        resizeMethod = function() {
            self.ownRefenceWidth = currentWidthFn();
            // console.log("CURRENT WIDTH: ", self.ownRefenceWidth);

            if(self.isSingleColumnInt !== (self.ownRefenceWidth < self.oneColumnBreakpoint)) {
                self.isSingleColumnInt = (self.ownRefenceWidth < self.oneColumnBreakpoint);
                $scope.$digest();
            }
        };

        angular.element($window).bind('resize', resizeMethod);

        $scope.$on('destroy', function() {
            angular.element($window).unbind('resize', resizeMethod);
        });

        $scope.isImage = function (attribute) {
            if (attribute.value === 'promotion') {
                return true;
            }
        };

        $scope.getAttributeImage = function (attribute) {
            if (attribute.value === 'promotion') {
                return 'img/percent.png';
            }
            else {
                return '';
            }
        };

        $scope.getAttributeIcon = function (attribute) {
            switch (attribute.value) {
                case 'greendot':
                    return 'mdi-icon-dark-green mdi-recycle';
                case 'danger':
                    return 'mdi-icon-red mdi-alert';
                case 'invest':
                    return 'mdi-icon-blue mdi-bank';
                case 'core':
                    return 'mdi-icon-grey mdi-google-nearby';
                case 'new':
                    return 'mdi-icon-yellow mdi-creation';
                default:
                    return 'hide-element';
            }
        }
    }
}]);
/**
 * Directive to write a two column table, which consists of two two column tables
 */
angular.module('impactx.product').directive('ixTwoColumnTable', function() {
    return {
        scope: {
            label: '=',
            data: '=',
            isSingleColumn: '=?',
            oneColumnBreakpoint: '=?',
            useWindowWidth: '=?',
            widthElementId: '=?',
            isIconSet: "=?",
            highlightSearchText: "=?"
        },
        restrict: 'E',
        controller: 'ixTwoColumnTableController as ctrl',
        templateUrl: 'shared/displayelements/templates/twocolumntable.html',
        transclude: true
    };
});